/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { cssMap, cx, jsx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	countLoading: {
		backgroundColor: token('color.background.accent.gray.subtlest'),
		borderRadius: token('radius.small'),
		height: '16px',
		width: '32px',
	},
});

export const ResultCountLoading = () => {
	return <Box xcss={cx(styles.countLoading)}
	testId="result-count-loading"
	/>;
};
